import type {
  WhatsappIntegration,
  WhatsappIntegrationBody,
  WhatsappOutbound,
  WhatsAppTemplate,
} from "@/schemas/whatsapp.schema";
import { api } from "@/services/api";

export interface WhatsappBusinessTokenValidation {
  app_id: string;
  type: string;
  application: string;
  data_access_expires_at: number;
  expires_at: number;
  is_valid: boolean;
  issued_at: number;
  scopes: string[];
  granular_scopes: { scope: string }[];
  user_id: string;
}

export const whatsappApi = {
  async updateIntegration(body: WhatsappIntegrationBody): Promise<WhatsappIntegration> {
    const { data } = await api.post<WhatsappIntegration>("/whatsapp-business", body);

    return data;
  },

  async getIntegration() {
    const { data } = await api.get<WhatsappIntegration | null>("/whatsapp-business");

    return data;
  },

  async validateToken(token: string) {
    const { data } = await api
      .get<WhatsappBusinessTokenValidation | { is_valid: false }>(
        "/whatsapp-business/validate-token",
        {
          params: { token },
        }
      )
      .catch(() => ({ data: { is_valid: false } }));

    return data;
  },

  async getNumbers(businessId: string) {
    const { data } = await api.get<{
      phone_numbers: { id: string; phone_number: string }[];
    }>("/whatsapp-business/numbers", {
      params: { business_id: businessId },
    });

    return data.phone_numbers;
  },

  async getTemplates(uuid: string) {
    const { data } = await api.get<{
      data: WhatsAppTemplate[];
    }>(`/whatsapp-business/templates/${uuid}`);

    return data.data;
  },

  async sendMessage(uuid: string, body: WhatsappOutbound) {
    await api.post(`/whatsapp-business/send-message/${uuid}`, body);
  },
};
